package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.model.AuthenticationInfo
import com.karawek.core.auth.model.OAuthProvider
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class AuthenticateWithOAuthUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(
        provider: OAuthProvider,
    ): Result<AuthenticationInfo> {
        return authenticator.authenticateWithOAuth(provider)
    }
}
